"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ProductImage = _interopRequireDefault(require("@sprinx/react-com/ProductImage"));

var _Link = _interopRequireDefault(require("@sprinx/react-mui-components/Link"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      width: '100%',
      borderRight: '1px solid rgba(0,0,0,.1)',
      '&:last-of-type': {
        borderRight: 'none'
      },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      minWidth: 130
    },
    imageContainer: {},
    link: {
      width: '100%',
      '&:hover': {
        textDecoration: 'none'
      }
    },
    image: {
      width: '100%',
      height: '100%'
    },
    img: {
      maxWidth: 105
    },
    label: {
      textTransform: theme.text.textTransformUppercase,
      fontWeight: 300,
      textAlign: 'center',
      marginTop: theme.spacing(3.5),
      color: theme.palette.common.black,
      paddingRight: theme.spacing(0.5),
      paddingLeft: theme.spacing(0.5)
    }
  };
}, {
  name: 'CatalogueCategoryListItem'
});
var mediaSizeMap = {
  mini: 'original',
  small: 'original',
  normal: 'original',
  big: 'original'
};

var CatalogueCategoryListItem = /*#__PURE__*/_react.default.forwardRef(function CatalogueCategoryListItem(_ref, ref) {
  var category = _ref.category,
      pClasses = _ref.classes,
      className = _ref.className,
      size = _ref.size,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["category", "classes", "className", "size"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement(_Link.default, {
    to: category.href,
    className: classes.link
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref
  }, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react.default.createElement(_ProductImage.default, {
    src: category.image,
    alt: category.label,
    size: size,
    className: classes.img,
    mediaSizeMap: mediaSizeMap
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: classes.label
  }, t(category.label, {
    acceptString: true
  }))));
});

process.env.NODE_ENV !== "production" ? CatalogueCategoryListItem.propTypes = {
  category: _propTypes.default.shape({
    code: _propTypes.default.string,
    href: _propTypes.default.string,
    image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.string))]),
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.shape({
      language: _propTypes.default.string.isRequired,
      text: _propTypes.default.string
    }))])
  }).isRequired,
  classes: _propTypes.default.shape({
    image: _propTypes.default.string,
    imageContainer: _propTypes.default.string,
    img: _propTypes.default.string,
    label: _propTypes.default.string,
    link: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  size: _propTypes.default.oneOf(['mini', 'small', 'normal', 'big'])
} : void 0;
CatalogueCategoryListItem.defaultProps = {
  classes: undefined,
  className: undefined,
  size: undefined
};
var _default = CatalogueCategoryListItem;
exports.default = _default;